import { useState } from 'react';
import DefaultIconButton from './DefaultIconButton';
import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { MoreVert } from '@mui/icons-material';

const PageHeader = ({ action, icon, header, label, disabled, headerColor }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 2,
        mb: 2,
        width: '100%',
      }}
    >
      <Typography variant="h5" gutterBottom sx={headerColor ? { color: headerColor } : undefined}>
        {header}
      </Typography>

      {isMobile ? (
        <>
          <IconButton onClick={handleMenuClick}>
            <MoreVert />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => {
                action();
                handleMenuClose();
              }}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              {label}
            </MenuItem>
          </Menu>
        </>
      ) : (
        <>
          <DefaultIconButton
            action={action}
            icon={icon}
            label={label}
            disabled={disabled}
          />
        </>
      )}
    </Box>
  );
};

export default PageHeader;
